<template>
  <!--  <button
      class="nc-star"
      :class="{ 'nc-star&#45;&#45;active': isInNetwork }"
      :title="isInNetwork ? 'Verwijder uit netwerk' : 'Voeg toe aan netwerk'"
      @click.prevent.stop="toggle"
    >
      <span class="material-symbols-outlined nc-star__icon">star</span>
    </button>-->
  <DsButton
    icon="star"
    icon-fill-color="white"
    class="!mr-0"
    @click.prevent.stop="toggle"
    :label="isInNetwork ? 'Verwijder uit netwerk' : 'Voeg toe aan netwerk'"
    variant="rounded"
    size="small"
  />
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { ACTION_TYPES } from '@/store/modules/network-contacts.js'
  // ACTION_TYPES.FETCH is dispatched on created to warm the contacts cache (no-op if already loaded)

  export default defineComponent({
    name: 'NetworkContactStar',
    props: {
      actorId: {
        type: String,   // elastic_id — the frontend identifier for actors
        required: true,
      },
      actorName: {
        type: String,
        default: '',
      },
      actorRole: {
        type: String,
        default: '',
      },
      actorImage: {
        type: String,
        default: '',
      },
    },
    created() {
      this.$store.dispatch(ACTION_TYPES.FETCH)
    },
    computed: {
      isInNetwork(): boolean {
        return this.$store.getters.isNetworkContact(this.actorId)
      },
    },
    methods: {
      toggle() {
        if (this.isInNetwork) {
          this.$store.dispatch(ACTION_TYPES.REMOVE_CONTACT, this.actorId)
        } else {
          this.$store.dispatch(ACTION_TYPES.ADD_CONTACT, {
            elasticId: this.actorId,
            name: this.actorName,
            role: this.actorRole,
            image: this.actorImage,
          })
        }
      },
    },
  })
</script>

<style scoped lang="scss">
  /*.nc-star {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(4px);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, transform 0.1s;
    padding: 0;

    &:hover {
      background: white;
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.9);
    }
  }

  .nc-star__icon {
    font-size: 18px;
    color: #c6c5d2;
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    transition: color 0.15s, font-variation-settings 0.15s;

    .nc-star--active & {
      color: #f1c040;
      font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
    }
  }*/
</style>
